"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TicketsModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
var _Table = require("../Table/Table");
var _classnames = _interopRequireDefault(require("classnames"));
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/ka");
var _lodash = _interopRequireDefault(require("lodash"));
var _reactDraggable = _interopRequireWildcard(require("react-draggable"));
var _TicketsModalModule = _interopRequireDefault(require("./TicketsModal.module.css"));
var _modal = require("../assets/icons/modal");
var _excluded = ["draggable", "onChange", "onCancel", "className", "data"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var filterTypes = [{
  key: -1,
  label: 'ყველა'
}, {
  key: 1,
  label: 'მოგებული'
}, {
  key: 2,
  label: 'წაგებული'
}, {
  key: 0,
  label: 'აქტიური'
}];
var tableKeys = ['TicketId', 'EntryDate', 'Amount', 'EstimatedWins', 'WinAmount', 'TicketType', 'status'];
var tableHeadings = {
  TicketId: 'ბილეთის ნომერი',
  EntryDate: 'თარიღი',
  Amount: 'თანხა',
  EstimatedWins: 'სავ. მოგება',
  WinAmount: 'მოგება',
  TicketType: 'ტიპი',
  status: 'სტატუსი'
};
var TicketsModal = function TicketsModal(_ref) {
  var draggable = _ref.draggable,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel,
    className = _ref.className,
    data = _ref.data,
    props = _objectWithoutProperties(_ref, _excluded);
  _moment.default.locale('ka');
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    variant = _useState2[0],
    setVariant = _useState2[1];
  var _useState3 = (0, _react.useState)({
      from: (0, _moment.default)().startOf('month').format('YYYY-MM-DD'),
      to: (0, _moment.default)(new Date()).format('YYYY-MM-DD'),
      status: filterTypes[0].key
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    filters = _useState4[0],
    setFilters = _useState4[1];
  var modalRef = (0, _react.useRef)();
  var DraggableModalDialog = (0, _react.useCallback)(function (props) {
    return /*#__PURE__*/_react.default.createElement(_reactDraggable.default, {
      handle: '.modal-header',
      nodeRef: modalRef
    }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Dialog, _extends({
      ref: modalRef
    }, props)));
  }, []);
  (0, _react.useEffect)(function () {
    onChange(filters);
  }, [filters]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    onHide: onCancel,
    contentClassName: (0, _classnames.default)(_TicketsModalModule.default.modal, variant ? _TicketsModalModule.default.light : _TicketsModalModule.default.dark, draggable ? _TicketsModalModule.default.draggable : null, className),
    animation: !draggable,
    dialogAs: draggable ? DraggableModalDialog : _reactBootstrap.Modal.Dialog
  }, props), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: _TicketsModalModule.default.header,
    style: {
      '--close': "url(".concat(_modal.CloseBlack, ")")
    },
    closeButton: true
  }, /*#__PURE__*/_react.default.createElement("h1", null, "\u10D1\u10D8\u10DA\u10D4\u10D7\u10D4\u10D1\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    id: "variant",
    type: "switch",
    className: _TicketsModalModule.default.switch,
    checked: variant,
    onChange: function onChange() {
      return setVariant(function (prevState) {
        return !prevState;
      });
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _TicketsModalModule.default.body
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: _TicketsModalModule.default.filters
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _TicketsModalModule.default.inputGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8:"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "date",
    value: filters.from,
    onChange: function onChange(e) {
      return setFilters(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          from: e.target.value
        });
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "-\u10D3\u10D0\u10DC")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _TicketsModalModule.default.inputGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8:"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "date",
    value: filters.to,
    onChange: function onChange(e) {
      return setFilters(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          to: e.target.value
        });
      });
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "-\u10DB\u10D3\u10D4"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 2,
    className: _TicketsModalModule.default.buttons
  }, _lodash.default.map(filterTypes, function (item) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, {
      key: item.key,
      className: filters.status === item.key ? _TicketsModalModule.default.active : null,
      "data-variant": item.key,
      onClick: function onClick() {
        return setFilters(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            status: item.key
          });
        });
      }
    }, item.label);
  }))), /*#__PURE__*/_react.default.createElement(_Table.Table, {
    variant: 'secondary',
    bordered: true,
    keys: tableKeys,
    headings: tableHeadings,
    data: data.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        status: /*#__PURE__*/_react.default.createElement("span", {
          "data-variant": item.status === '1' ? 'success' : 'danger'
        }, item.status === '1' ? 'მოგებული' : 'წაგებული')
      });
    })
  }), data.length === 0 && /*#__PURE__*/_react.default.createElement("h1", null, "\u10DB\u10D8\u10D7\u10D8\u10D7\u10D4\u10D1\u10E3\u10DA \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10E8\u10D8 \u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10D1\u10D8\u10DA\u10D4\u10D7\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0")));
};
exports.TicketsModal = TicketsModal;
TicketsModal.propTypes = {
  show: _propTypes.default.bool,
  centered: _propTypes.default.bool,
  size: _propTypes.default.oneOf(['sm', null, 'lg', 'xl']),
  draggable: _propTypes.default.bool,
  data: _propTypes.default.arrayOf(_propTypes.default.object),
  onChange: _propTypes.default.func,
  onCancel: _propTypes.default.func
};
TicketsModal.defaultProps = {
  show: true,
  centered: true,
  size: 'xl',
  draggable: true,
  data: []
};